import type { ListingCategory, ListingStatus } from '@/types/rental.types';

/**
 * Listing presentation shared by Rental Management and the Moderation Center. Lives here rather
 * than in features/rentals/constants.ts because common-components may not import from a feature.
 */

/** Card image: emoji + gradient per category, using mobileApp PhotoSlot tone stripes. */
export const CATEGORY_META: Record<
  ListingCategory,
  { icon: string; label: string; gradient: string }
> = {
  entertainment: { icon: '🎮', label: 'Entertainment', gradient: 'linear-gradient(135deg,#FBE5DF,#F8CFC4)' },
  study: { icon: '📚', label: 'Study', gradient: 'linear-gradient(135deg,#FBE6EE,#F5CFDD)' },
  electronics: { icon: '💻', label: 'Electronics', gradient: 'linear-gradient(135deg,#E4EEFC,#D2E3FA)' },
  other: { icon: '📦', label: 'Other', gradient: 'linear-gradient(135deg,#DEF2E9,#C5EBD8)' },
};

export const LISTING_STATUS_LABEL: Record<
  ListingStatus,
  { label: string; tone: 'success' | 'warn' | 'danger' | 'info' | 'neutral' }
> = {
  live: { label: 'Active', tone: 'success' },
  rented: { label: 'Rented', tone: 'info' },
  pending_approval: { label: 'Pending', tone: 'warn' },
  removed: { label: 'Removed', tone: 'danger' },
};
